/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { IDLE_MODAL_SEEN_KEY } from "@/components/Common/Containers/ContentContainer";
import axios from "axios";
import { getCookie } from "../utils/generalUtilities";

function setCookie(name: string, value: string, days: number) {
  let expires = "";
  const isDevelopment = process.env.NODE_ENV === "development";

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }

  const secureFlag = isDevelopment ? "secure:false" : "secure:true";

  document.cookie =
    name + "=" + value + expires + "; path=/;" + secureFlag + "samesite=strict";
}

export const logoutUser = () => {
  localStorage.clear();
  //toast.error("Session is expired, please login again :))");
  //window.location.href = "/login";
  window.location.href = "/login"; // Use this since we are using hashRouter
  window.location.reload();
  return false;
};

export const getLinkTokenFromStore = () => {
  getCookie("authToken");
  return "";
};

export interface Error {
  status: number;
  message: string;
}

const getToken = () => {
  const retrievedToken = getCookie("loginRes");
  //return "";
  return retrievedToken;
};

const authToken = getToken();

/* const getBaseURL = () => {
  const nodeEnv = import.meta.env.VITE_NODE_ENV;
  return !nodeEnv || nodeEnv === "development"
    ? import.meta.env.VITE_APP_API_BASE_URL
    : import.meta.env.VITE_APP_PROD_URL;
}; */

function getHeaders() {
  const headers = {
    "Content-Type": "application/json",
    "Ocp-Apim-Subscription-Key": import.meta.env.VITE_APP_API_KEY,
  };

  const url = window.location.href;

  if (authToken && !url.includes("/login")) {
    return {
      ...headers,
      Authorization: `Bearer ${getToken()}`,
    };
  }

  return { ...headers };
}

const getBaseURL = () => {
  return import.meta.env.VITE_APP_API_BASE_URL;
};

/* const api = axios.create({
  baseURL: getBaseURL(),
  headers: getHeaders(),
  withCredentials: false,
}); */

// Default API
const api = axios.create({
  baseURL: getBaseURL(),
  headers: getHeaders(),
  withCredentials: false,
});

//Account System API

/* const apiAccounting = axios.create({
  baseURL: getAccountBaseURL(),
  //baseURL: `https://cors-anywhere.herokuapp.com/${getAccountBaseURL()}`,
  headers: getAccountingHeaders(import.meta.env.VITE_APP_API_KEY),
  //headers: getHeaders(import.meta.env.VITE_APP_API_KEY),

  withCredentials: false,
}); */

window.trying_refresh_token = false;
const getLoginRes = () => getCookie("loginRes");

const setLoginRes = (data) => {
  return setCookie("loginRes", JSON.stringify(data), 7);
};

const createLock = () => {
  let lockStatus = false;

  const release = () => {
    lockStatus = false;
  };

  const acuire = () => {
    if (lockStatus === true) return false;
    lockStatus = true;
    return true;
  };

  return {
    lockStatus: lockStatus,
    acuire: acuire,
    release: release,
  };
};
const lock = createLock(); // create a lock

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};
let numberOfUnauthenticatedRequest = 0;
let consecutiveNonRefreshable401s = 0;

api.interceptors.response.use(
  (response) => {
    consecutiveNonRefreshable401s = 0;
    return response;
  },
  async (err) => {
    const customError: Error = {
      status: err.response.status,
      statusText: err.response.statusText,
      message: err.response.data,
    };
    const originalRequest = err.config;
    if (err.response) {
      const tokenExpiredHeader = err.response.headers["token-expired"];
      if (err.response.status === 401 && tokenExpiredHeader) {
        numberOfUnauthenticatedRequest++;
        try {
          if (numberOfUnauthenticatedRequest > 1) {
            return new Promise(function (resolve, reject) {
              failedQueue.push({ resolve, reject });
            })
              .then((token) => {
                originalRequest.headers["Authorization"] = "Bearer " + token;
                return axios.request(originalRequest);
              })
              .catch((err) => {
                return Promise.reject(err);
              });
          }
          return new Promise(function (resolve) {
            (() => {
              if (lock.acuire()) {
                api
                  .post(`/UserAccount/Refresh`, getLoginRes(), {
                    headers: {
                      "Content-Type": "application/json",
                    },
                  })
                  .then((res) => {
                    lock.release();
                    window.dispatchEvent(
                      new CustomEvent("re-authenticate", {
                        detail: {
                          accessToken: res.data.accessToken,
                          refreshToken: res.data.refreshToken,
                        },
                      }),
                    );
                    originalRequest.headers["Authorization"] =
                      "Bearer " + res.data.accessToken;

                    setLoginRes(res.data);
                    numberOfUnauthenticatedRequest = 0;
                    // Reset idle modal seen flag so a fresh warning can appear if needed
                    localStorage.removeItem(IDLE_MODAL_SEEN_KEY);
                    processQueue(null, res.data.accessToken);
                    resolve(axios.request(originalRequest));
                  })
                  // eslint-disable-next-line @typescript-eslint/no-unused-vars
                  .catch((err) => {
                    lock.release();
                  });
              }
            })();
          });
        } catch (_error) {
          if (_error.response && _error.response.data) {
            return Promise.reject(_error.response.data);
          }
          return Promise.reject(customError);
        }
      } else if (err.response.status === 401) {
        consecutiveNonRefreshable401s++;

        if (consecutiveNonRefreshable401s >= 3) {
          consecutiveNonRefreshable401s = 0;
        }

        return Promise.reject(customError);
      } else {
        return Promise.reject(customError);
      }
    } else {
      return Promise.reject(customError);
    }
  },
);
let failedQueue = [];
api.interceptors.request.use(async (req) => {
  try {
    const tokenRes = getLoginRes() ? JSON.parse(getLoginRes()) : null;

    if (tokenRes) req.headers.Authorization = `Bearer ${tokenRes.accessToken}`;
    return req;
  } catch {
    // If there's an error parsing the token, we can choose to silently ignore it or log it.
  }
});

export default api;

export { getLoginRes, setLoginRes };
